import { ReferenceTable } from "../../types/interfaces/admin/ReferenceResponse";
import { toSnakeCase } from "./caseConverters";

export const getReferenceRoute = (
  tables: ReferenceTable[],
  schema: string,
  table: string
): string => {
  const found = tables.find(
    (rt) => rt.schemaName === schema && rt.tableName === toSnakeCase(table)
  );
  if (!found) throw new Error(`Route not found for ${schema}/${table}`);
  return found.route;
};

export const getReferenceFields = (
  tables: ReferenceTable[],
  schema: string,
  table: string
): string[] => {
  const found = tables.find(
    (rt) => rt.schemaName === schema && rt.tableName === toSnakeCase(table)
  );
  if (!found) throw new Error(`Fields not found for ${schema}/${table}`);
  return found.fields;
};